import { Link, createFileRoute } from '@tanstack/react-router'
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

// Catch-all inside the guard, so unknown URLs also require a session.
export const Route = createFileRoute('/_authed/$')({ component: NotFound })

function NotFound() {
	return (
		<Card className="max-w-md">
			<CardHeader>
				<CardDescription className="font-bold text-primary">404</CardDescription>
				<CardTitle className="text-xl text-[#122947]">Page not found</CardTitle>
				<Link to="/" className="mt-2 text-sm font-semibold text-muted-foreground hover:text-primary">
					Back to home
				</Link>
			</CardHeader>
		</Card>
	)
}
